/**
 * Sorts a list of dealers alphabetically by name and filters out dealers
 * without a complete address (both city and state must be present and non-empty).
 * @param {Array} dealersList - The list of dealer objects to be sorted and filtered.
 * @returns {Array} A new array of dealer objects, sorted alphabetically by name, excluding those without city or state in their address.
 */
const sortDealersAlphabetically = (dealersList) => {

  if (!dealersList) {
    return [];
  }

  return dealersList
    .filter(dealer =>
      dealer?.address &&
      dealer?.address?.state?.trim() &&
      dealer?.address?.city?.trim()
    )
    .sort((a, b) => a.name.localeCompare(b.name));
};

export { sortDealersAlphabetically };
